<template>
  <base-container ref="container" :isLoading="loading">
    <ArtisanGrid
      ref="grid"
      metaKey="OpEvaluateWork"
      rightWidth="20%"
      :metaInited="metaInited"
      :handleQuery="handleQuery"
      :handleData="handleData"
      :searchPosition="patientId ? 'top' : 'left'"
      @row-click="rowClick"
    >

      <template #billTimeSearch>
        <el-date-picker
          style="width: 100%"
          size="mini"
          v-model="filterDate"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :clearable="false"
          valueFormat="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template #rightAside>
        <OpExamine :projectList="projectList"
                   :billId="editRow.id"
                   :status="editRow.status"
                   :remark="editRow.evaluateRemark"
                   @evaluated="evaluated"
                   @viewDetail="showProjectDetail"
        >

        </OpExamine>
      </template>
      <template #pageRight> </template>
      <template #bottom>
        <div style="height: 300px; position: relative">
          <RecordDetail
            style="flex: 1"
            ref="detail"
            :billId="editRow.id"
          ></RecordDetail>
        </div>
      </template>
      <template #gridBtnAfter>
        <el-row type="flex" justify="space-between" align="middle">
          <el-row>

          </el-row>

          <el-button
            icon="el-icon-refresh"
            size="mini"
            type="danger"
            @click="manualSyncBills"
          >
            手动同步
          </el-button>
        </el-row>
      </template>
      <template #status="{ row }">
        <el-tag :type="statusMap[row.status].type" size="small">
          <span :class="payStatusMap[row.payStatus].type">
            {{ payStatusMap[row.payStatus].label }}
          </span>
          |
          <span>{{ statusMap[row.status].label }}</span>
        </el-tag>
      </template>
      <template #reserveDate="{ row }">
        <div v-if="row.scheduleId">
          {{ row.reserveDate }} {{ row.startPoint }}-{{ row.endPoint }}
        </div>
        <span v-else>-</span>
      </template>
      <template #patientGender="{ row }">
        {{ getGenderLabel(row.patientGender) }}
      </template>
    </ArtisanGrid>
    <artisan-dialog
      ref="editDialog"
      title="术前检查详情"
      :visible.sync="detailShow"
      height="80%"
      width="70%"
    >
      <div style="display: flex; width: 100%;height: 100%; justify-content: space-between;">
        <artisan-group title="项目列表" style="width: 49%;">
          <el-table :data="projectList" border>
            <el-table-column
            header-align="center"
            align="center"
            prop="projectName"
            label="类别"
            width="100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.reportType === 'jc'" >检查</span>
                <span v-if="scope.row.reportType === 'jy'" >检验</span>
              </template>
            </el-table-column>
            <el-table-column
            header-align="center"
            align="center"
            prop="projectName"
            label="项目名称"
            width="200"
            >
            </el-table-column>
            <el-table-column
            header-align="center"
            align="center"
            prop="reportStatus"
            label="报告状态"
            width="100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.reportStatus === '1'" class="color-success">已出报告</span>
                <span v-if="scope.row.reportStatus === '0'" class="color-danger">待出报告</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope" v-if="scope.row.reportStatus === '1'">
                <i class="el-icon-view" style="color: #1989fa !important"></i>
                <span class="color-primary margin-h3" @click="viewReport(scope.row)">查看</span>
              </template>
            </el-table-column>
          </el-table>
        </artisan-group>
        <artisan-group title="报告单详情" style="width: 49%; padding: 10px 30px;">
          <JyReport v-if="projectRow.reportType === 'jy'" :reportId="projectRow.reportId"  :report-type="projectRow.reportType"></JyReport>
          <JcReport v-if="projectRow.reportType === 'jc'" :reportId="projectRow.reportId"  :report-type="projectRow.reportType"></JcReport>
        </artisan-group>
      </div>

      <template #footer>
        <el-button
          type="primary"
          size="mini"
          @click="detailShow = false"
        >
          返回
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import moment from "moment";
import RecordDetail from "./RecordDetail.vue";
import { getClinicTypeLabel, getGenderLabel } from "@/util/util";
import OpExamine from "@/views/op/OpExamine";
import JyReport from "@/views/op/JyReport";
import JcReport from "@/views/op/JcReport";
import {getReportList,syncBills} from "@/api/op/record";

export default {
  components: {
    OpExamine,
    RecordDetail,
    JyReport,
    JcReport
  },
  data() {
    const start = moment().subtract(7, "d").toDate();
    return {
      detailShow: false,
      patientId: "",
      projectList: [],
      projectRow: {},
      statusMap: {
        wait: {
          label: "待评估",
          type: "info",
        },
        pass: {
          label: "已通过",
          type: "success",
        },
        reject: {
          label: "已驳回",
          type: "danger",
        },
      },
      payStatusMap: {
        paid: {
          label: "已支付",
          type: "color-success",
        },
        unpaid: {
          label: "未支付",
          type: "color-info",
        },
        refund: {
          label: "已退费",
          type: "color-danger",
        },
      },
      loading: false,
      showDialog: false,
      dialogLoading: false,
      editRow: {},
      hosId: "first",
      filterDate: [start, new Date()],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.patientId) {
      this.patientId = this.$route.query.patientId;
    }
  },
  computed: {
  },
  methods: {
    getClinicTypeLabel,
    getGenderLabel,
    metaInited(option) {
      if (this.patientId) {
        option.columns.forEach((c) => {
          c.isSearch = c.code == "billTime";
        });
        option.columns.find((c) => c.code == "billTime").searchSlot = true;
      } else {
        option.columns.find((c) => c.code == "billTime").searchSlot = true;
      }
    },
    handleQuery(param) {
      if (this.filterDate.length) {
        let start = moment(this.filterDate[0]).format("YYYY-MM-DD");
        let end = moment(this.filterDate[1]).format("YYYY-MM-DD");
        param.billTime = start + " 00:00:00," + end + " 23:59:59";
      }
      if (this.patientId) {
        param.patientId = this.patientId;
      }
      return param;
    },
    handleData(data) {
      if (data.length) {
        this.editRow = data[0];
        this.queryReport();
      }
    },
    reloadGrid() {
      this.$refs.grid.reload();
    },
    rowClick(row) {
      this.editRow = row;
      this.queryReport();
    },
    queryReport() {
      getReportList({billId: this.editRow.id}).then(
        (res) => {
        this.projectList = res.data.data;
        if (this.projectList.length){
          this.projectRow = this.projectList[0];
        }
      })
    },

    manualSyncBills() {
      this.$refs.container
        .confirm({ msg: "确认手动同步手术申请单？" })
        .then(() => {
          this.loading = true;
          syncBills()
            .then(() => {
              this.$message({
                type: "success",
                message: "同步申请单成功！",
              });
              this.loading = false;
              this.$refs.grid.reload();
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },

    evaluated(res) {
      this.editRow.status = res.status;
      this.editRow.evaluateRemark = res.evaluateRemark;
      this.$refs.detail.loadData();
    },
    showProjectDetail(project) {
      this.projectRow = project;
      this.detailShow = true;

    },
    viewReport(row) {
      this.projectRow = row;
    }

  },
};
</script>

<style lang="scss" scoped>
.el-calendar-table {
  .el-calendar-day {
    height: 40px !important;
  }
}
.dashed-line {
  border-top: 1px dashed #DCDFE6;
  height: 0;
  margin: 10px 0;
}
</style>
